import { createContext } from 'react';
import type { PartialAppContext } from '/index.d';

const Context = createContext<PartialAppContext>({});

export default Context;
